import DateFnsUtils from "@date-io/date-fns";
import {
  Card,
  CardContent,
  DialogActions,
  Fab,
  FormControl,
  FormGroup,
  Grid,
  IconButton,
  MenuItem,
} from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Icon from "@material-ui/core/Icon";
import { withStyles } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import { Add, History, Search } from "@material-ui/icons";
import Dialog from "components/Dialog";
import SelectAutoComplete from "components/SelectAutoComplete";
import TableData from "components/TableData";
import datetimeHelper from "helper/datetime-helper";
import _, { debounce } from "lodash";
import { InlineDatePicker, MuiPickersUtilsProvider } from "material-ui-pickers";
import moment from "moment";
import { enqueueSnackbar } from "notistack";
import PropTypes from "prop-types";
import React, { Component } from "react";
import {
  SelectValidator,
  TextValidator,
  ValidatorForm,
} from "react-material-ui-form-validator";
import { connect } from "react-redux";
import { mapActionsToProps as rolesAction } from "redux/roles";
import { addUserApi, editUserApi, mapActionsToProps } from "redux/user";

import { globalHistory } from "./../../history";
import DialogUpdateUser from "./components/DialogUpdateUser";

const renderRules = (rule, roles) => {
  if (
    _.values(roles)?.length &&
    _.values(roles)[0].allowedRoles &&
    _.values(roles)[0].allowedRoles.filter((item) => item.roleName === rule)
      .length
  ) {
    return _.values(roles)[0].allowedRoles.filter(
      (item) => item.roleName === rule
    )[0].roleDisplayName;
  }
};

class ListUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filters: {
        order: "createdAt DESC",
        where: {},
        page: 0,
        pageSize: 20,
      },
      filtersHistory: {
        order: "createdAt DESC",
        where: {
          gte: datetimeHelper.toFormat(new Date(), "YYYY-MM-DD"),
          lte: datetimeHelper.toFormat(new Date(), "YYYY-MM-DD"),
        },
        page: 0,
        pageSize: 20,
      },
      showPassword: false,
      role: "",
      modalHistory: false,
      modalView: false,
      selectedUser: "",
      allUser: [],
      historyLog: null,
      loadingSaveUser: false,
      openUpdateUser: false,
      updateItem: null,
      deleteItem: null,
    };
  }

  async componentDidMount() {
    this.history = globalHistory();
    await this.props.getRole();
    await this.itemInit();
  }

  static getDerivedStateFromProps(props, state) {
    if (
      JSON.parse(JSON.stringify(state.allUser)) !==
        JSON.parse(JSON.stringify(_.values(props.allUser))) &&
      !state.allUser.length
    ) {
      return {
        allUser: _.values(props.allUser),
      };
    }
    return null;
  }

  listColumns = [
    {
      id: "username",
      numeric: true,
      disablePadding: false,
      label: "Tài khoản",
    },
    { id: "fullname", numeric: true, disablePadding: false, label: "Họ tên" },
    {
      id: "phoneNumber",
      numeric: true,
      disablePadding: false,
      label: "Số điện thoại",
    },
    { id: "email", numeric: true, disablePadding: false, label: "Email" },
    { id: "role", numeric: true, disablePadding: false, label: "Quyền" },
    {
      id: "status",
      numeric: true,
      disablePadding: false,
      label: "Trạng thái hoạt động",
    },
    {
      disablePadding: false,
      label: "Trạng thái chat",
      customValue: (item) => {
        return item?.isActiveChat ? "Đang hoạt động" : "Ngưng hoạt động";
      },
    },
    {
      id: "createdAt",
      numeric: true,
      disablePadding: false,
      label: "Thời gian tạo",
    },
    { id: "action", numeric: true, disablePadding: false, label: "Hành động" },
  ];

  listColumnsHistory = [
    {
      id: "function",
      numeric: true,
      disablePadding: false,
      label: "Chức năng",
    },
    { id: "option", numeric: true, disablePadding: false, label: "Thao tác" },
    {
      id: "user",
      _attributes: "username",
      numeric: true,
      disablePadding: false,
      label: "Tài khoản",
    },
    {
      id: "createdAt",
      numeric: true,
      disablePadding: false,
      label: "Thời gian thao tác",
    },
    { id: "view", numeric: true, disablePadding: false, label: "Chi tiết" },
  ];

  itemInit() {
    const where = {};
    const and = [];
    const { filters } = this.state;
    for (const key in filters.where) {
      if (filters.where.hasOwnProperty(key)) {
        const element = filters.where[key];
        if (element) {
          switch (key) {
            case "username":
            case "fullname":
            case "phoneNumber":
            default: {
              if (key.startsWith("from") || key.startsWith("to")) {
                if (key == "from") {
                  and.push({ time: { gte: this.state.filters.where.from } });
                  where.and = and;
                } else {
                  and.push({ time: { lte: this.state.filters.where.to } });
                  where.and = and;
                }
              } else {
                where[key] = element;
              }
              break;
            }
          }
        }
      }
    }
    this.props.getAllUser(filters.order, filters.pageSize, filters.page, {
      where,
    });
    this.props.countUser({ where: where });
    this.props.getAllUserHistory();
  }

  itemInitHistory() {
    const where = {};
    const and = [];
    const { filtersHistory } = this.state;
    for (const key in filtersHistory.where) {
      if (filtersHistory.where.hasOwnProperty(key)) {
        const element = filtersHistory.where[key];
        if (element) {
          switch (key) {
            case "username":
            case "fullname":
            case "phoneNumber":
            default: {
              if (key.startsWith("gte") || key.startsWith("lte")) {
                if (key == "gte") {
                  and.push({
                    createdAt: {
                      gte: `${this.state.filtersHistory.where.gte} 00:00:00`,
                    },
                  });
                  where.and = and;
                } else {
                  and.push({
                    createdAt: {
                      lte: `${this.state.filtersHistory.where.lte} 23:59:59`,
                    },
                  });
                  where.and = and;
                }
              } else {
                where[key] = element;
              }
              break;
            }
          }
        }
      }
    }
    this.props.getUserHistory(
      filtersHistory.order,
      filtersHistory.pageSize,
      filtersHistory.page,
      {
        where,
      }
    );
    this.props.countUserHistory({ where: where });
  }

  handleClose = () => {
    this.setState({
      openUpdateUser: false,
      modalDelete: false,
      updateItem: null,
      deleteItem: null,
    });
  };

  openModalEdit = (item) => {
    this.setState({ openUpdateUser: true, updateItem: item });
  };

  openModalDelete = (item) => {
    this.setState({ modalDelete: true, deleteItem: item });
  };

  handleChangePage = (e, page) => {
    const { filters } = this.state;
    this.setState({ page });
    filters.page = page * filters.pageSize;
    this.itemInit();
  };

  handleChangePageHistory = (e, pageHistoy) => {
    const { filtersHistory } = this.state;
    this.setState({ pageHistoy });
    filtersHistory.page = pageHistoy * filtersHistory.pageSize;
    this.itemInitHistory();
  };

  handleChangeRowsPerPage = (e) => {
    const { filters } = this.state;
    filters.pageSize = e.target.value;
    this.setState(
      {
        filters,
      },
      () => {
        this.itemInit();
      }
    );
  };

  handleChangeRowsPerPageHistory = (e) => {
    const { filtersHistory } = this.state;
    filtersHistory.pageSize = e.target.value;
    this.setState(
      {
        filtersHistory,
      },
      () => {
        this.itemInitHistory();
      }
    );
  };

  handleSearch = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    const { filters } = this.state;
    filters.where[name] = { like: value };
    this.setState({
      filters,
    });
  };

  handleSearchHistory = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    const { filtersHistory } = this.state;
    if (value) {
      filtersHistory.where[name] = { like: value };
    } else {
      delete filtersHistory.where[name];
    }
    this.setState({
      filtersHistory,
    });
  };

  handleSubmit = (e) => {
    const { filters } = this.state;
    filters.skip = 0;
    this.setState(
      {
        disable: false,
        filters: {
          ...filters,
          page: 0,
        },
      },
      () => {
        setTimeout(() => {
          this.itemInit();
        }, 1000);
      }
    );
  };

  handleSubmitHistory = (e) => {
    const { filtersHistory } = this.state;
    filtersHistory.skip = 0;
    if (this.state.selectedUser) {
      filtersHistory.where["userId"] = this.state.selectedUser;
    } else {
      delete filtersHistory.where["userId"];
    }
    this.setState(
      {
        disable: false,
        filtersHistory: {
          ...filtersHistory,
          page: 0,
        },
      },
      () => {
        setTimeout(() => {
          this.itemInitHistory();
        }, 1000);
      }
    );
  };

  handleDateChangeStart = (gte) => {
    const { filtersHistory } = this.state;
    filtersHistory.where.gte = datetimeHelper.toFormat(gte, "YYYY-MM-DD");
    this.setState({ gte });
  };

  handleDateChangeEnd = (lte) => {
    const { filtersHistory } = this.state;
    filtersHistory.where.lte = datetimeHelper.toFormat(lte, "YYYY-MM-DD");
    this.setState({ lte });
  };

  handleCreateModel = () => {
    this.setState({
      openUpdateUser: true,
      updateItem: null,
    });
  };

  handleSubmitUpdateUser = async (formValue) => {
    const { id, ...userInfo } = formValue;
    this.setState({ loadingSaveUser: true });
    try {
      if (!id) {
        await addUserApi(userInfo);
        this.setState({ openUpdateUser: false });
        this.itemInit();
      } else {
        await editUserApi(formValue);
        this.setState({ openUpdateUser: false });
        this.itemInit();
      }
    } catch (error) {
      enqueueSnackbar(
        `${!id ? "Tạo mới" : "Cập nhật"} thất bại! ${
          error.response?.data?.error?.message || error.message
        }`,
        {
          variant: "error",
        }
      );
    }
    this.setState({ loadingSaveUser: false });
  };

  handleDelete = () => {
    this.props.deleteUser(this.state.deleteItem.id);
    setTimeout(
      function () {
        this.setState({ modalDelete: false, deleteItem: null });
        this.itemInit();
      }.bind(this),
      500
    );
  };

  onHandleKeyPress = (e) => {
    if (e.key === "Enter") {
      this.handleSubmit();
    }
  };

  onHandleKeyPressHistory = (e) => {
    if (e.key === "Enter") {
      this.handleSubmitHistory();
    }
  };

  handleShowHistoryLog = () => {
    this.itemInitHistory();
    this.setState({ modalHistory: true });
  };

  handleView = (historyLog) => {
    this.setState({ modalView: true, historyLog });
  };

  handleSearchUser = (text) => {
    const { listAgents } = this.props;
    this.setState({
      allUser: this.filterCustomers(_.values(listAgents), text),
    });
  };

  filterCustomers = (array, search) => {
    if (search) {
      return search
        ? array.filter(
            (item) =>
              (item &&
                item.username &&
                item.username.toLowerCase().includes(search.toLowerCase())) ||
              (item &&
                item.fullname &&
                item.fullname.toLowerCase().includes(search.toLowerCase()))
          )
        : array;
    }
    return array;
  };

  render() {
    const {
      classes,
      listUser,
      count,
      countHistory,
      listUserHistory,
      listRole,
    } = this.props;
    const { filters, filtersHistory, modalDelete } = this.state;
    const listUserResult =
      typeof listUser === "object"
        ? Object.keys(listUser).map((key) => listUser[key])
        : listUser;
    const listUserHistoryResult =
      typeof listUserHistory === "object"
        ? Object.keys(listUserHistory).map((key) => listUserHistory[key])
        : listUserHistory;
    const listRoleResult =
      typeof listRole === "object"
        ? Object.keys(listRole).map((key) => listRole[key])
        : listRole;

    return (
      <React.Fragment>
        <ValidatorForm
          ref="form"
          onSubmit={this.handleSubmit}
          onError={(errors) => console.log(errors)}
          className={classes.form}>
          <Card className={classes.card}>
            <CardContent>
              <FormControl className={classes.form}>
                <FormGroup className={classes.form}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Grid
                      container
                      spacing={24}
                      style={{ alignItems: "center" }}>
                      <Grid item md={3}>
                        <TextValidator
                          id="outlined-full-width"
                          margin="normal"
                          label="Tài khoản"
                          variant="outlined"
                          className={classes.input}
                          onChange={this.handleSearch}
                          value={
                            filters.where.username
                              ? filters.where.username.like
                              : ""
                          }
                          onKeyPress={(e) => this.onHandleKeyPress(e)}
                          name="username"
                        />
                      </Grid>
                      <Grid item md={3}>
                        <TextValidator
                          id="outlined-full-width"
                          margin="normal"
                          label="Họ tên"
                          variant="outlined"
                          className={classes.input}
                          onChange={this.handleSearch}
                          value={
                            filters.where.fullname
                              ? filters.where.fullname.like
                              : ""
                          }
                          onKeyPress={(e) => this.onHandleKeyPress(e)}
                          name="fullname"
                        />
                      </Grid>
                      <Grid item md={3}>
                        <TextValidator
                          id="outlined-full-width"
                          margin="normal"
                          label="Số điện thoại"
                          variant="outlined"
                          className={classes.input}
                          onChange={this.handleSearch}
                          value={
                            filters.where.phoneNumber
                              ? filters.where.phoneNumber.like
                              : ""
                          }
                          onKeyPress={(e) => this.onHandleKeyPress(e)}
                          name="phoneNumber"
                          // type="number"
                        />
                      </Grid>
                      <Grid item md={3}>
                        <Tooltip title="Tìm kiếm" disableFocusListener>
                          <Fab
                            color="primary"
                            aria-label="Search"
                            className={classes.fab}
                            onClick={this.handleSubmit}>
                            <Search />
                          </Fab>
                        </Tooltip>
                      </Grid>
                    </Grid>
                  </MuiPickersUtilsProvider>
                </FormGroup>
              </FormControl>
            </CardContent>
          </Card>
        </ValidatorForm>
        <TableData
          {...this.props}
          nameTable="Danh sách tài khoản"
          items={listUserResult}
          rowsPerPage={filters.pageSize}
          count={count ? count.count : 0}
          page={
            filters.pageSize === 20
              ? filters.page / 20
              : filters.pageSize === 40
              ? filters.page / 40
              : filters.pageSize === 60
              ? filters.page / 60
              : filters.pageSize === 80
              ? filters.page / 80
              : filters.page / 100
          }
          rowItems={this.listColumns}
          allowCreate={true}
          handleEdit={this.openModalEdit}
          handleDelete={this.openModalDelete}
          handleChangePage={this.handleChangePage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          handleConfig={this.handleConfig}
          createAction={
            <div style={{ display: "flex" }}>
              <Tooltip title="Hiển thị lịch sử thao tác" disableFocusListener>
                <Fab
                  color="primary"
                  aria-label="add"
                  className={classes.fab}
                  size="small"
                  onClick={this.handleShowHistoryLog}>
                  <History className={classes.add} />
                </Fab>
              </Tooltip>
              <Tooltip
                title="Thêm mới"
                disableFocusListener
                style={{ marginLeft: 10 }}>
                <Fab
                  color="primary"
                  aria-label="add"
                  className={classes.fab}
                  size="small"
                  onClick={this.handleCreateModel}>
                  <Add className={classes.add} />
                </Fab>
              </Tooltip>
            </div>
          }
        />

        {this.state.openUpdateUser && (
          <DialogUpdateUser
            onSubmit={this.handleSubmitUpdateUser}
            item={this.state.updateItem}
            open={this.state.openUpdateUser}
            onClose={this.handleClose}
            loadingSaveUser={this.state.loadingSaveUser}
            listRoleResult={listRoleResult?.[0]?.allowedRoles}
          />
        )}

        {this.state.deleteItem && this.state.modalDelete && (
          <Dialog
            open={modalDelete}
            title={`Bạn có muốn xóa tài khoản ${
              this.state.deleteItem?.username || ""
            }`}
            button={true}
            onSubmit={this.handleDelete}
            onClose={this.handleClose}
          />
        )}

        <Dialog
          open={this.state.modalHistory}
          onClose={() =>
            this.setState({
              modalHistory: false,
              filtersHistory: {
                order: "createdAt DESC",
                where: {
                  gte: datetimeHelper.toFormat(new Date(), "YYYY-MM-DD"),
                  lte: datetimeHelper.toFormat(new Date(), "YYYY-MM-DD"),
                },
                page: 0,
                pageSize: 20,
              },
            })
          }
          title={"KnowledgeBase"}
          maxWidth="xl"
          fullScreen={true}
          input={
            <React.Fragment>
              <AppBar className={classes.appBar} style={{ color: "#fff" }}>
                <Toolbar>
                  <IconButton
                    color="inherit"
                    onClick={() => {
                      this.setState({
                        modalHistory: false,
                        filtersHistory: {
                          order: "createdAt DESC",
                          where: {
                            gte: datetimeHelper.toFormat(
                              new Date(),
                              "YYYY-MM-DD"
                            ),
                            lte: datetimeHelper.toFormat(
                              new Date(),
                              "YYYY-MM-DD"
                            ),
                          },
                          page: 0,
                          pageSize: 20,
                        },
                      });
                    }}
                    aria-label="Close">
                    <Icon>close</Icon>
                  </IconButton>
                  <Typography
                    variant="h6"
                    color="inherit"
                    className={classes.flex}>
                    Lịch sử thao tác
                  </Typography>
                </Toolbar>
              </AppBar>
              <ValidatorForm
                ref="form"
                onSubmit={this.handleSubmitHistory}
                onError={(errors) => console.log(errors)}
                className={classes.form}>
                <Card className={classes.card}>
                  <CardContent>
                    <FormControl className={classes.form}>
                      <FormGroup className={classes.form}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <Grid
                            container
                            spacing={24}
                            style={{ alignItems: "center" }}>
                            <Grid item md={4}>
                              <SelectValidator
                                id="outlined-full-width"
                                margin="normal"
                                select
                                SelectProps={{
                                  MenuProps: {
                                    className: classes.menu,
                                    shrink: true,
                                  },
                                }}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                label="Thao tác"
                                variant="outlined"
                                className={classes.input}
                                onChange={this.handleSearchHistory}
                                value={
                                  filtersHistory.where.method
                                    ? filtersHistory.where.method.like
                                    : ""
                                }
                                name="method">
                                <MenuItem>Tất cả</MenuItem>
                                <MenuItem key="create" value="create">
                                  Tạo mới
                                </MenuItem>
                                <MenuItem key="replaceById" value="replaceById">
                                  Sửa đổi
                                </MenuItem>
                                <MenuItem key="deleteById" value="deleteById">
                                  Xóa
                                </MenuItem>
                              </SelectValidator>
                            </Grid>
                            <Grid item md={4}>
                              <SelectAutoComplete
                                label={"Tài khoản"}
                                data={
                                  this.state.allUser &&
                                  this.state.allUser.length > 0
                                    ? this.state.allUser.map((val) => {
                                        return {
                                          id: val.id,
                                          label: val
                                            ? `${val.username} - ${val.fullname}`
                                            : "",
                                        };
                                      })
                                    : []
                                }
                                onSearch={debounce(
                                  (text) => this.handleSearchUser(text),
                                  300
                                )}
                                onChange={(item) => {
                                  this.setState(
                                    {
                                      selectedUser: item ? item.id : "",
                                    },
                                    () => {
                                      if (this.state.selectedUser) {
                                        this.handleSubmitHistory();
                                      }
                                    }
                                  );
                                }}
                                onClear={true}
                                name="userId"
                              />
                            </Grid>
                            <Grid item md={4}>
                              <InlineDatePicker
                                margin="normal"
                                label="Thời gian bắt đầu"
                                variant="outlined"
                                className={classes.input}
                                value={filtersHistory.where.gte}
                                maxDate={new Date()}
                                format="dd-MM-yyyy"
                                onChange={this.handleDateChangeStart}
                                name="timeFrom"
                                keyboard
                                required={true}
                                ampm={false}
                                invalidDateMessage="Định dạng Ngày không đúng"
                                maxDateMessage="Ngày lớn hơn ngày tối đa"
                                minDateMessage="Ngày nhỏ hơn ngày tối thiểu"
                                // validators={["required"]}
                                // errorMessages={[`Không được để trống`]}
                              />
                            </Grid>
                            <Grid item md={4}>
                              <InlineDatePicker
                                margin="normal"
                                label="Thời gian kết thúc"
                                variant="outlined"
                                className={classes.input}
                                value={filtersHistory.where.lte}
                                maxDate={new Date()}
                                minDate={filtersHistory.where.gte}
                                format="dd-MM-yyyy"
                                onChange={this.handleDateChangeEnd}
                                name="timeTo"
                                keyboard
                                required={true}
                                ampm={false}
                                invalidDateMessage="Định dạng Ngày không đúng"
                                maxDateMessage="Ngày lớn hơn ngày tối đa"
                                minDateMessage="Ngày nhỏ hơn ngày tối thiểu"
                                // validators={["required"]}
                                // errorMessages={[`Không được để trống`]}
                              />
                            </Grid>
                            <Grid item md={4}>
                              <Tooltip title="Tìm kiếm" disableFocusListener>
                                <Fab
                                  color="primary"
                                  aria-label="Search"
                                  className={classes.fab}
                                  onClick={this.handleSubmitHistory}>
                                  <Search />
                                </Fab>
                              </Tooltip>
                            </Grid>
                          </Grid>
                        </MuiPickersUtilsProvider>
                      </FormGroup>
                    </FormControl>
                  </CardContent>
                </Card>
              </ValidatorForm>
              <TableData
                {...this.props}
                nameTable="Danh sách thao tác"
                items={listUserHistoryResult}
                rowsPerPage={filtersHistory.pageSize}
                count={countHistory ? countHistory.count : 0}
                page={
                  filtersHistory.pageSize === 20
                    ? filtersHistory.page / 20
                    : filtersHistory.pageSize === 40
                    ? filtersHistory.page / 40
                    : filtersHistory.pageSize === 60
                    ? filtersHistory.page / 60
                    : filtersHistory.pageSize === 80
                    ? filtersHistory.page / 80
                    : filtersHistory.page / 100
                }
                rowItems={this.listColumnsHistory}
                handleChangePage={this.handleChangePageHistory}
                handleChangeRowsPerPage={this.handleChangeRowsPerPageHistory}
                handleView={this.handleView}
              />
            </React.Fragment>
          }
        />
        <Dialog
          open={this.state.modalView}
          fullScreen={false}
          maxWidth={"lg"}
          fullWidth={true}
          onClose={() => this.setState({ modalView: false, historyLog: null })}
          title={"Chi tiết thao tác"}
          input={
            <ValidatorForm
              ref="form"
              onError={(errors) => console.log(errors)}
              className={classes.form}>
              <FormControl className={classes.form}>
                <Grid container spacing={24}>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <TextValidator
                      id="outlined-full-width"
                      margin="normal"
                      label="Chức năng"
                      variant="outlined"
                      className={classes.input}
                      value={this.state.historyLog?.function}
                      name="fromNumber"
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <TextValidator
                      id="outlined-full-width"
                      margin="normal"
                      label="Tài khoản"
                      variant="outlined"
                      className={classes.input}
                      value={this.state.historyLog?.user?.username}
                      name="fromNumber"
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <TextValidator
                      id="outlined-full-width"
                      margin="normal"
                      label="Thao tác"
                      variant="outlined"
                      className={classes.input}
                      value={this.state.historyLog?.option}
                      name="fromNumber"
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <TextValidator
                      id="outlined-full-width"
                      margin="normal"
                      label="Thời gian thao tác"
                      variant="outlined"
                      className={classes.input}
                      value={moment(this.state.historyLog?.createdAt).format(
                        "YYYY-MM-DD HH:mm:ss"
                      )}
                      name="fromNumber"
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <TextValidator
                      id="outlined-full-width"
                      margin="normal"
                      label="IP"
                      variant="outlined"
                      className={classes.input}
                      value={this.state.historyLog?.ip}
                      name="fromNumber"
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <TextValidator
                      id="outlined-full-width"
                      margin="normal"
                      label="User Agent"
                      variant="outlined"
                      className={classes.input}
                      value={this.state.historyLog?.userAgent}
                      name="fromNumber"
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                  </Grid>
                </Grid>
              </FormControl>
              {this.state?.historyLog?.beforeData &&
              this.state?.historyLog?.afterData ? (
                <table className={classes.table}>
                  <tr>
                    <th className={classes.td}>
                      <Typography style={{ fontWeight: "bold" }}>
                        Tên trường
                      </Typography>
                    </th>
                    <th className={classes.td}>
                      <Typography style={{ fontWeight: "bold" }}>
                        Giá trị trước thao tác
                      </Typography>
                    </th>
                    <th className={classes.td}>
                      <Typography style={{ fontWeight: "bold" }}>
                        Giá trị sau thao tác
                      </Typography>
                    </th>
                  </tr>
                  <tr>
                    <td className={classes.td}>
                      <Typography>Mã tài khoản</Typography>
                    </td>
                    <td className={classes.td}>
                      {this.state?.historyLog?.beforeData["Mã tài khoản"]}
                    </td>
                    <td className={classes.td}>
                      {this.state?.historyLog?.afterData["Mã tài khoản"]}
                    </td>
                  </tr>
                  <tr>
                    <td className={classes.td}>
                      <Typography>Tên tài khoản</Typography>
                    </td>
                    <td className={classes.td}>
                      {this.state?.historyLog?.beforeData["Tên tài khoản"]}
                    </td>
                    <td className={classes.td}>
                      {this.state?.historyLog?.afterData["Tên tài khoản"]}
                    </td>
                  </tr>
                  <tr>
                    <td className={classes.td}>
                      <Typography>Mật khẩu</Typography>
                    </td>
                    <td className={classes.td}>
                      {this.state?.historyLog?.beforeData["Mật khẩu"]}
                    </td>
                    <td className={classes.td}>
                      {this.state?.historyLog?.afterData["Mật khẩu"]}
                    </td>
                  </tr>
                  <tr>
                    <td className={classes.td}>
                      <Typography>Phân quyền</Typography>
                    </td>
                    <td className={classes.td}>
                      {renderRules(
                        this.state?.historyLog?.beforeData["Phần quyền"],
                        listRole
                      )}
                    </td>
                    <td className={classes.td}>
                      {renderRules(
                        this.state?.historyLog?.afterData["Phần quyền"],
                        listRole
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td className={classes.td}>
                      <Typography>Email</Typography>
                    </td>
                    <td className={classes.td}>
                      {this.state?.historyLog?.beforeData["Email"]}
                    </td>
                    <td className={classes.td}>
                      {this.state?.historyLog?.afterData["Email"]}
                    </td>
                  </tr>
                  <tr>
                    <td className={classes.td}>
                      <Typography>Số điện thoại</Typography>
                    </td>
                    <td className={classes.td}>
                      {this.state?.historyLog?.beforeData["Số điện thoại"]}
                    </td>
                    <td className={classes.td}>
                      {this.state?.historyLog?.afterData["Số điện thoại"]}
                    </td>
                  </tr>
                  <tr>
                    <td className={classes.td}>
                      <Typography>Hoạt động</Typography>
                    </td>
                    <td className={classes.td}>
                      {this.state?.historyLog?.beforeData["Hoạt đông"]
                        ? "True"
                        : "Fail"}
                    </td>
                    <td className={classes.td}>
                      {this.state?.historyLog?.afterData["Hoạt đông"]
                        ? "True"
                        : "Fail"}
                    </td>
                  </tr>
                </table>
              ) : (
                <table className={classes.table}>
                  <tr>
                    <th className={classes.td}>
                      <Typography style={{ fontWeight: "bold" }}>
                        Tên trường
                      </Typography>
                    </th>
                    <th className={classes.td}>
                      <Typography style={{ fontWeight: "bold" }}>
                        Giá trị
                      </Typography>
                    </th>
                  </tr>
                  <tr>
                    <td className={classes.td}>
                      <Typography>Mã tài khoản</Typography>
                    </td>
                    <td className={classes.td}>
                      {this.state?.historyLog?.data["Mã tài khoản"]}
                    </td>
                  </tr>
                  <tr>
                    <td className={classes.td}>
                      <Typography>Tên tài khoản</Typography>
                    </td>
                    <td className={classes.td}>
                      {this.state?.historyLog?.data["Tên tài khoản"]}
                    </td>
                  </tr>
                  <tr>
                    <td className={classes.td}>
                      <Typography>Mật khẩu</Typography>
                    </td>
                    <td className={classes.td}>
                      {this.state?.historyLog?.data["Mật khẩu"]}
                    </td>
                  </tr>
                  <tr>
                    <td className={classes.td}>
                      <Typography>Phân quyền</Typography>
                    </td>
                    <td className={classes.td}>
                      {renderRules(
                        this.state?.historyLog?.data["Phần quyền"],
                        listRole
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td className={classes.td}>
                      <Typography>Email</Typography>
                    </td>
                    <td className={classes.td}>
                      {this.state?.historyLog?.data["Email"]}
                    </td>
                  </tr>
                  <tr>
                    <td className={classes.td}>
                      <Typography>Số điện thoại</Typography>
                    </td>
                    <td className={classes.td}>
                      {this.state?.historyLog?.data["Số điện thoại"]}
                    </td>
                  </tr>
                  <tr>
                    <td className={classes.td}>
                      <Typography>Hoạt động</Typography>
                    </td>
                    <td className={classes.td}>
                      {this.state?.historyLog?.data["Hoạt đông"]
                        ? "True"
                        : "Fail"}
                    </td>
                  </tr>
                </table>
              )}
              <DialogActions>
                <Button
                  onClick={() =>
                    this.setState({ modalView: false, historyLog: null })
                  }
                  color="secondary"
                  className={classes.button}>
                  Hủy
                </Button>
              </DialogActions>
            </ValidatorForm>
          }
        />
        <Dialog open={this.props.loadingHistory} title={<CircularProgress />} />
      </React.Fragment>
    );
  }
}

ListUser.propTypes = {
  classes: PropTypes.object.isRequired,
};

const styles = (theme) => ({
  root: {
    width: "100%",
  },
  card: {
    maxWidth: "100%",
    overflow: "unset",
  },
  form: {
    width: "100%",
  },
  input: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
    "& p": {
      position: "absolute",
      top: "55px",
    },
  },
  grid: {
    width: "100%",
    padding: theme.spacing.unit * 3,
  },
  table: {
    width: "100%",
  },
  td: {
    border: "1px solid #dddddd",
    textAlign: "left",
    padding: "8px",
  },
});

const mapStateToProps = (state) => ({
  listUser: state.user.users,
  listUserHistory: state.user.histories,
  count: state.user.count,
  listRole: state.roles.roles,
  countHistory: state.user.countHistory,
  loadingHistory: state.user.loadingHistory,
  allUser: state.user.allUser,
});

const Roles = connect(null, rolesAction)(ListUser);
ListUser = connect(mapStateToProps, mapActionsToProps)(Roles);

export default withStyles(styles)(ListUser);
